module.exports = __webpack_public_path__ + "static/img/1915_phase_function_Paper_Points.5d98a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1915_phase_function_Paper_Points.png
// module id = CqS9
// module chunks = 0